import React, { FC, MouseEvent, useContext, useState } from "react";
import { Link } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { isEmpty } from "lodash";
import { Hyperlink, RxStrategy } from "../../typescript/interfaces/data";
import { Permissions } from "../../typescript/types/data";
import { VisibilityContext } from "../../context";
import { usePermissions } from "../../hooks";
import IconLinks from "../Popups/IconLinks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconEnabled: {
      color: theme.palette.primary.main,
      cursor: "pointer",
      width: "auto",
      height: "auto",
      display: "flex",
      alignContent: "center",
      alignItems: "center",
    },
    iconDisabled: {
      filter: "grayscale(1) opacity(0.3)",
      cursor: "default",
      width: "auto",
      height: "auto",
      display: "flex",
      alignContent: "center",
      alignItems: "center",
    },
  })
);

interface LinkWrapperProps {
  data: RxStrategy[] | Hyperlink[] | string;
  popup?: string;
  permissions?: Permissions;
}

const LinkWrapper: FC<LinkWrapperProps> = ({ data, popup, permissions, children }) => {
  const classes = useStyles();
  const hasPermission = usePermissions(permissions);

  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLElement) | null>(null);
  const isOpen = Boolean(anchorEl);

  const handleOpenPopover = (event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);

  const handleClosePopover = () => setAnchorEl(null);

  const handleIconClick = (event: MouseEvent<HTMLElement>) => {
    if (permissions && !hasPermission) {
      setVisibilityContext({
        ...visibilityContext,
        marketing: true,
      });
    } else {
      isOpen ? handleClosePopover() : handleOpenPopover(event);
    }
  };

  if (data.length > 0 && typeof data === "string") {
    return (
      <Link href={data} target="_blank" underline="none" className={classes.iconEnabled}>
        {children}
      </Link>
    );
  } else if (data.length > 0 && popup && typeof data !== "string") {
    return (
      <span className={classes.iconEnabled} onClick={(event) => handleIconClick(event)}>
        {children}
        <IconLinks
          popupTitle={popup}
          links={data}
          isOpen={isOpen}
          anchorEl={anchorEl}
          closePopover={handleClosePopover}
        />
      </span>
    );
  }

  return <span className={classes.iconDisabled}>{children}</span>;
};

export default LinkWrapper;
